import React, { Fragment } from "react";

import { Cms as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponents } from "../PageSkeleton/Toolbox";

interface Props {
    value: Value;
}

export const ReusableContentBlock = ({ value }: Props) => {
    return (
        <StreamField
            tagName={Fragment}
            components={toolboxComponents}
            value={value.content}
        />
    );
};
